import {
  Autocomplete,
  Box,
  Checkbox,
  InputAdornment,
  ListSubheader,
} from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Chip,
  CircularProgress,
  Divider,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import { assignAnalyst, portMatch } from "../../redux/actions/adminAction";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import dayjs from "dayjs";
import Select from "react-select";

import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { DateTime } from "luxon";
import moment from "moment";
import { FaSearch } from "react-icons/fa";

export default function EditDialog({ open, handleClose, data, refreshData }) {
  const formatDateAndTime = (dateWithTime) => {
    if (dateWithTime) {
      const utcTime = DateTime.fromISO(dateWithTime, { zone: "utc" });
      const istTime = utcToZonedTime(utcTime.toJSDate(), "Asia/Kolkata");

      return format(istTime, "PPpp");
    } else {
      return null;
    }
  };
  let already_assign_date_data = formatDateAndTime(
    data?.analysis_sense_data?.assigned_date
  );
  let already_due_date_data = formatDateAndTime(
    data?.analysis_sense_data?.due_date
  );

  const analysisOptions = [
    { value: 1, label: "Old Type" },
    { value: 2, label: "New Type" },
    { value: 3, label: "Extra Events" },
  ];

  const [analysts, setAnalysts] = React.useState([]);
  const [reviewers, setReviewers] = React.useState([]);
  const [organizer, setOrganizer] = React.useState([]);
  const [analysisType, setAnalysisType] = React.useState();

  const today = new Date();

  const [selectedAssignDate, setSelectedAssignDate] = React.useState(null);
  const [selectedDueDate, setSelectedDueDate] = React.useState(null);

  const dispatch = useDispatch();

  const { token } = useSelector((state) => state.auth);
  const {
    allAnalyst,
    allOrganizer,
    updatingAnalysts,
    portingAccounts,
    updatingAllDate,
  } = useSelector((state) => state.admin);

  React.useEffect(() => {
    if (data?.analyst_details) {
      setAnalysts(data?.analyst_details?.map((i) => i.id) || []);
      setReviewers(data?.reviewer_details?.map((i) => i.id) || []);
      setOrganizer(data?.organizer_details?.map((i) => i.id) || []);
    }
  }, [data]);

  React.useEffect(() => {
    handleAssignDateChange();
    handleDueDateChange();
  }, [data]);

  const handleAnalystChange = (value) => {
    // const {
    //   target: { value },
    // } = event;
    // setAnalysts(value);
    setAnalysts([...value]);
  };

  const handleReviewerChange = (value) => {
    // const {
    //   target: { value },
    // } = event;
    setReviewers([...value]);
  };

  const handleOrganizerChange = (event) => {
    const {
      target: { value },
    } = event;
    setOrganizer(value);
  };

  const handleAssignDateChange = (date) => {
    setSelectedAssignDate(date);
  };

  const handleDueDateChange = (date) => {
    setSelectedDueDate(date);
  };

  const handleUpdate = async () => {
    let analyst_data = analysts
      .map((i) => allAnalyst.find((u) => u.id === i)?.username)
      .filter((value) => value !== null && value !== undefined);

    let reviewer_data = reviewers
      .map((i) => allAnalyst.find((u) => u.id === i)?.username)
      .filter((value) => value !== null && value !== undefined);

    let account_data = organizer
      .map((i) => allOrganizer.find((u) => u.id === i)?.id)
      .filter((value) => value !== null && value !== undefined);

    let Assign_date_data = data?.analysis_sense_data?.assigned_date;
    let Due_date_data = data?.analysis_sense_data?.due_date;

    await dispatch(
      assignAnalyst({
        data: {
          analyst_username: analyst_data,
          assigned_date: selectedAssignDate
            ? selectedAssignDate.$d
            : Assign_date_data
            ? ""
            : today,
          due_date: selectedDueDate
            ? selectedDueDate.$d
            : Due_date_data
            ? ""
            : "",
          match_id: data.id,
          analysis_setup: analysisType?.value,
          reviewer_username: reviewer_data,
        },
        token,
      })
    );

    await dispatch(
      portMatch({
        data: {
          organizer_list: account_data,
          port_list: [data.id],
          port_type: "match",
        },
        token,
      })
    );

    refreshData();

    // while (updatingAnalysts || portingAccounts || updatingAllDate) {
    //   await new Promise(resolve => setTimeout(resolve, 100));
    // }

    // setTimeout(async () => {
    //   if (!updatingAnalysts && !portingAccounts && !updatingAllDate) {
    handleClose();
    //     await dispatch(getAllMatches({ token }));
    //   }
    // }, 1000);
  };

  if (!data) {
    return null;
  }
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: "40%",
        },
      }}
      BackdropProps={{ style: { backgroundColor: "#12121250" } }}
    >
      {/* {(updatingAnalysts || portingAccounts) && (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      )} */}
      <DialogTitle>Edit Assignments</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please also inform analyst and reviewer after updation.
        </DialogContentText>
        <Divider sx={{ my: 1 }} />
        <Stack spacing={2}>
          <Stack
            direction="row"
            spacing={1}
            justifyContent="center"
            alignItems="center"
          >
            <Typography>Match ID : </Typography>
            <Typography>{data.id} </Typography>
            <Chip
              label={`${data?.team_a_details?.name} vs ${data?.team_b_details?.name}`}
              color="success"
            />
          </Stack>

          <Autocomplete
            limitTags={2}
            multiple
            options={allAnalyst}
            value={analysts?.map((i) => allAnalyst.find((u) => u.id === i))}
            onChange={(_, newValue) =>
              handleAnalystChange(newValue.map((val) => val.id))
            }
            disableCloseOnSelect
            getOptionLabel={(option) => option.name}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox checked={selected} style={{ marginRight: 8 }} />
                {option.name}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Assigned Analyst"
                placeholder="Search analyst..."
                size="small"
              />
            )}
          />

          <Autocomplete
            limitTags={2}
            multiple
            options={allAnalyst}
            value={reviewers?.map((i) => allAnalyst.find((u) => u.id === i))}
            onChange={(_, newValue) =>
              handleReviewerChange(newValue.map((val) => val.id))
            }
            disableCloseOnSelect
            getOptionLabel={(option) => option.name}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox checked={selected} style={{ marginRight: 8 }} />
                {option.name}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Assigned Reviewer"
                placeholder="Search reviewer..."
                size="small"
              />
            )}
          />

          {/* <TextField
            select
            SelectProps={{
              multiple: true,
              label: "Select Analysts",
              renderValue: (selected) =>
                selected
                  ?.map((i) => allAnalyst.find((u) => u.id === i)?.name)
                  .join(",  "),
            }}
            margin="dense"
            id="assigned_analyst"
            label="Assigned Analyst"
            defaultValue={analysts}
            onChange={handleAnalystChange}
            fullWidth
            size="small"
            variant="outlined"
          >
            {allAnalyst.map((item) => (
              <MenuItem key={item.id} value={item?.id}>
                <Checkbox checked={!!analysts.find((i) => i === item.id)} />
                {item.name}
              </MenuItem>
            ))}
          </TextField> */}

          {/* <TextField
            select
            SelectProps={{
              multiple: true,
              label: "Select Reviewers",
              renderValue: (selected) =>
                selected
                  ?.map((i) => allAnalyst.find((u) => u.id === i)?.name)
                  .join(",  "),
            }}
            margin="dense"
            id="assigned_reviewer"
            label="Assigned Reviewer"
            defaultValue={reviewers}
            onChange={handleReviewerChange}
            fullWidth
            size="small"
            variant="outlined"
          >
            {allAnalyst.map((item) => (
              <MenuItem key={item.id} value={item?.id}>
                <Checkbox checked={!!reviewers.find((i) => i === item.id)} />
                {item.name}
              </MenuItem>
            ))}
          </TextField> */}

          <TextField
            select
            SelectProps={{
              multiple: true,
              label: "Select Analysts",
              renderValue: (selected) =>
                selected
                  ?.map((i) => allOrganizer.find((u) => u.id === i)?.name)
                  .join(",  "),
            }}
            margin="dense"
            id="assigned_organizer"
            label="Assigned Accounts"
            value={organizer}
            onChange={handleOrganizerChange}
            fullWidth
            size="small"
            variant="outlined"
          >
            {allOrganizer.map((item, index) => (
              <MenuItem key={item.id} value={item.id}>
                <Checkbox checked={!!organizer.find((i) => i === item.id)} />
                {item.id}:{item.name}
              </MenuItem>
            ))}
          </TextField>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDateTimePicker
              label="Assigned date"
              onChange={handleAssignDateChange}
              defaultValue={
                already_assign_date_data
                  ? dayjs(already_assign_date_data)
                  : dayjs(today)
              }
              slotProps={{
                actionBar: {
                  actions: ["clear", "cancel", "accept"],
                },
              }}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDateTimePicker
              label="Due Date"
              defaultValue={
                already_due_date_data ? dayjs(already_due_date_data) : null
              }
              slotProps={{
                actionBar: {
                  actions: ["clear", "cancel", "accept"],
                },
              }}
              onChange={handleDueDateChange}
            />
          </LocalizationProvider>

          <div>
            <div style={{ marginBottom: "0.6rem" }}>Analysis Type</div>
            <Select
              styles={{ marginBottom: "2rem" }}
              value={analysisType}
              onChange={setAnalysisType}
              options={analysisOptions}
              isSearchable={false}
            />
          </div>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleUpdate}
          disabled={updatingAnalysts || portingAccounts || updatingAllDate}
        >
          {updatingAnalysts || portingAccounts || updatingAllDate ? (
            <CircularProgress />
          ) : (
            "Update"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
